import Api from "utils/api";

export const fetchProposalDesignations = () => Api.PROPOSAL.DESIGNATIONS.get();

export const fetchDesignationProposalCount = async (designationId) => {
  const query =
    "query($designation_id: BigInt!) { designationProposalCount(designation_id: $designation_id) }";
  const { data } = await Api.GRAPHQL.GRAPHQL.post({
    data: JSON.stringify({
      operationName: null,
      query,
      variables: { designation_id: designationId },
    }),
  });
  return data.data.designationProposalCount;
};

export const createProposalDesignation = (data) =>
  Api.PROPOSAL.DESIGNATIONS.post({
    data,
  });

export const deleteProposalDesignation = (data) =>
  Api.PROPOSAL.DESIGNATIONS.delete({
    urlExtend: `/${data.id}`,
  });

export const bulkUpdateProposalDesignations = (data) =>
  Api.PROPOSAL.DESIGNATIONS.put({
    urlExtend: "/bulk",
    data: data,
  });
